import React from 'react'
import classes from './ErrorFallbackComponent.module.scss'

// Assets
import bugIcon from 'assets/icons/bug.svg'

function ErrorFallbackComponent() {
  return (
    <div className={classes.container}>
      <div className={classes.imageContainer}>
        <img src={bugIcon} alt="" />
      </div>
      <h1 className={classes.title}>Sorry, something went wrong</h1>
    </div>
  )
}

export default ErrorFallbackComponent
